import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import WidgetListingImages from "~widget/components/widget-listing-details/widget-listing-images"
import Box from "~components/shared/todo-lib-react-components/box"
import ListWithDividers from "~components/shared/list-with-dividers"
import type { ListingFieldsFragment } from "~graphql/generated/graphql"
import { useListingItems } from "~utils/hooks/use-listing-items"

export default function WidgetListingDetailsLeftColumn() {
    const styles = useStyles()

    const { listing } = useCheckoutFlow()
    const items = useItems({ listing })

    // For typescript.
    if (!listing) return null

    return (
        <Box style={styles.root}>
            <ListWithDividers items={items} />
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            width: { base: "100%", lg: "55%" },
            display: "flex",
            flexDirection: "column",
            gap: "24px",
        },
    })
}

function useItems({ listing }: { listing?: ListingFieldsFragment | null }) {
    const commonItems = useListingItems({ listing })

    if (!listing) return []

    return [
        {
            Component: <WidgetListingImages listing={listing} />,
        },
        ...commonItems,
    ]
}
